import React from 'react';
import {Card, CardActions, CardContent} from "@mui/material";
import {CardData, CardTitle} from "@atttomyx/react-components";
import {datetime} from "@atttomyx/shared-utils";
import {upsellUtils} from "../../utils";

const UpsellCard = (props) => {
    const { upsell, filters, children } = props;

    return <Card className="upsell-card" raised={true}>
        <CardContent>
            <CardTitle>
                {upsell.name}
            </CardTitle>
            <CardData
                filters={filters}
                data={upsell}
                keyToMetadata={{
                    landingPageUrl: {
                        title: "URL",
                    },
                    price: {
                        title: "Price",
                        formatter: upsellUtils.formatPrice,
                    },
                    order: {
                        title: "Index",
                    },
                    created: {
                        title: "Created",
                        formatter: datetime.getFullDateAndTime,
                    },
                    updated: {
                        title: "Updated",
                        formatter: datetime.getFullDateAndTime,
                    },
                }}
            />
        </CardContent>
        <CardActions disableSpacing={true}>
            {children}
        </CardActions>
    </Card>
}

export default UpsellCard;
